import { Language } from '@utils-global';

type OfficeLanguageNormalLanguageMap = {
  [key: string]: Language;
};
const officeLanguageNormalLanguageMap: OfficeLanguageNormalLanguageMap = {
  en: Language.English,
  'en-US': Language.English,
  'en-GB': Language.English,
  'en-AU': Language.English,
  'en-CA': Language.English,
  'en-NZ': Language.English,
  ar: Language.Arabic,
  'ar-SA': Language.Arabic,
  'ar-EG': Language.Arabic,
  'ar-MA': Language.Arabic,
  'ar-DZ': Language.Arabic,
  bg: Language.Bulgarian,
  'bg-BG': Language.Bulgarian,
  nl: Language.DutchBelgium,
  'nl-BE': Language.DutchBelgium,
  'nl-NL': Language.DutchNetherlands,
  ca: Language.Catalan,
  'ca-ES': Language.Catalan,
  'ca-AD': Language.Catalan,
  cs: Language.Czech,
  'cs-CZ': Language.Czech,
  da: Language.Danish,
  'da-DK': Language.Danish,
  'da-GL': Language.Danish,
  fi: Language.Finnish,
  'fi-FI': Language.Finnish,
  de: Language.German,
  'de-AT': Language.German,
  'de-DE': Language.German,
  'de-LI': Language.German,
  'de-LU': Language.German,
  'de-CH': Language.German,
  es: Language.Spanish,
  'es-ES': Language.Spanish,
  fr: Language.French,
  'fr-FR': Language.French,
  'fr-CA': Language.French,
  'fr-BE': Language.French,
  'fr-LU': Language.French,
  'fr-CH': Language.French,
  hr: Language.Croatian,
  'hr-HR': Language.Croatian,
  hu: Language.Hungarian,
  'hu-HU': Language.Hungarian,
  it: Language.Italian,
  'it-IT': Language.Italian,
  'it-CH': Language.Italian,
  'it-SW': Language.Italian,
  'it-VA': Language.Italian,
  ja: Language.Japanese,
  'ja-JP': Language.Japanese,
  no: Language.Norwegian,
  'no-NO': Language.Norwegian,
  nb: Language.Norwegian,
  'nb-NO': Language.Norwegian,
  nn: Language.Norwegian,
  'nn-NO': Language.Norwegian,
  pl: Language.Polish,
  'pl-PL': Language.Polish,
  pt: Language.Portuguese,
  'pt-BR': Language.PortugueseBrazil,
  'pt-PT': Language.Portuguese,
  ro: Language.Romanian,
  'ro-RO': Language.Romanian,
  ru: Language.Russian,
  'ru-RU': Language.Russian,
  sl: Language.Slovenian,
  'sl-SI': Language.Slovenian,
  sv: Language.Swedish,
  'sv-SE': Language.Swedish,
  'sv-FI': Language.Swedish,
  th: Language.Thai,
  'th-TH': Language.Thai,
  tr: Language.Turkish,
  'tr-TR': Language.Turkish,
  'tr-CY': Language.Turkish,
  uk: Language.Ukrainian,
  'uk-UA': Language.Ukrainian,
  zh: Language.Chinese,
  'zh-CN': Language.Chinese,
  'zh-HK': Language.Chinese,
  'zh-TW': Language.Chinese,
};

export const transformOfficeLanguageToTranslationLanguage = (officeLanguage: string): Language =>
  officeLanguageNormalLanguageMap[officeLanguage] ??
  officeLanguageNormalLanguageMap[officeLanguage.split('-')[0]] ??
  Language.English;
